var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSpotOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 15a2 2 0 110-4 2 2 0 010 4m0-6a4 4 0 100 8 4 4 0 000-8",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26.188C12.938 23.02 8 17.055 8 13a8 8 0 0116 0c0 4.055-4.938 10.02-8 13.188M16 3C10.477 3 6 7.477 6 13c0 7 10 16 10 16s10-9 10-16c0-5.523-4.478-10-10-10",
    fill: props.color
  })));
}

export default SvgIconSpotOutline;